/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import { LeadTaskType } from 'types/enums/LeadTaskType'
import { LeadTaskStatus } from 'types/enums/LeadTaskStatus'

export const useLeadTaskSchema = () => {
    const { t } = useTranslation()

    return useMemo(() => z.object({
        type: z.nativeEnum(LeadTaskType),
        status: z.nativeEnum(LeadTaskStatus),
        title: z
            .string()
            .trim()
            .min(2, t('Title must be at least 2 characters'))
            .max(200, t('Title must be at most 200 characters')),
        description: z
            .string()
            .trim()
            .max(2000, t('Description must be at most 2000 characters'))
            .optional()
            .nullable()
            .or(z.literal('')),
        due_at: z.date({
            message: t('Due date is required'),
        }),
        seller_id: z.number(),
    }), [t])
}

export type LeadTaskInputs = z.infer<ReturnType<typeof useLeadTaskSchema>>
